import React, { MouseEvent, useState } from 'react';
import Paper from '@mui/material/Paper';
import { DataTable } from '../../../ui';
import {
  OrganizationRowMenu,
  getOrganizationColumns,
  getOrganizationMenuItems,
} from '../functions';
import type { IOrganizationTableRow } from '../interfaces';

interface IOrganizationsTableProps {
  rows: IOrganizationTableRow[];
  onView: (row: IOrganizationTableRow) => void;
  onEdit: (row: IOrganizationTableRow) => void;
  onDelete: (row: IOrganizationTableRow) => void;
  onRowClick: (row: IOrganizationTableRow) => void;
}

export const OrganizationsTable: React.FC<IOrganizationsTableProps> = ({
  rows,
  onView,
  onEdit,
  onDelete,
  onRowClick,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedRow, setSelectedRow] = useState<IOrganizationTableRow | null>(null);

  const handleOpenMenu = (e: MouseEvent<HTMLButtonElement>, row: unknown): void => {
    setAnchorEl(e.currentTarget);
    setSelectedRow(row as IOrganizationTableRow);
  };

  const handleCloseMenu = (): void => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const columns = getOrganizationColumns(handleOpenMenu, handleCloseMenu, anchorEl);
  const menuItems = getOrganizationMenuItems({ onView, onEdit, onDelete });

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <DataTable
        columns={columns}
        data={rows}
        rowsPerPage={10}
        currentPage={1}
        totalRecords={rows.length}
        totalPages={1}
        onPageChange={() => {}}
        onClickRow={onRowClick}
      />
      <OrganizationRowMenu
        anchorEl={anchorEl}
        selectedRow={selectedRow}
        menuItems={menuItems}
        onClose={handleCloseMenu}
      />
    </Paper>
  );
};
